import { PageInfo, ProductReview, QueryVariablesTypes } from '@@types'
import { gql, useQuery } from '@apollo/client'

interface AllProductReviewsQuery {
  allProductReviews: {
    edges: ProductReview[]
    pageInfo: PageInfo
  }
}

export const GQL_QUERY_ALL_PRODUCT_REVIEWS = gql`
  query allProductReviews (
    $filter: NestedFilterInput,
    $pager: CommonPagerInput,
    $sort: CommonSortInput
  ) {
    allProductReviews(filter: $filter, pager: $pager, sort: $sort) {
      edges {
        id
        status
        customer_id
        customer {
          first_name
        }
        product_id
        rating
        comment
        created_at
      }
      pageInfo {
        page
        perPage
        lastPage
        next
      }
    }
  }
`

export const useFetchProductReviews = (variables: QueryVariablesTypes) => {
  const { data, loading, error, refetch } = useQuery<AllProductReviewsQuery, QueryVariablesTypes>(
    GQL_QUERY_ALL_PRODUCT_REVIEWS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

  const productReviews = data?.allProductReviews?.edges ?? []
  const pageInfo = data?.allProductReviews?.pageInfo

  return {
    productReviews,
    pageInfo,
    data,
    loading,
    error,
    refetch
  }
}
